import { ReportGrammarRules } from '../../../../../../../redux/config/customReport/types'
import { FunctionCategoryValue } from '../../../../../../../redux/context/customReports/typesCategory'
import { NodeError, NodesById, NormalizedBuilderNode, VisitorContext } from '../types'
import { NormalizedAbstractVisitor } from './NormalizedAbstractVisitor'

/**
 * ValidationVisitor normalisoidulle puurakenteelle
 * Validoi puun rakenteet sääntöjen mukaan
 */
export class NormalizedValidationVisitor extends NormalizedAbstractVisitor<NodeError[]> {
  private errors: NodeError[] = []

  constructor(rules: ReportGrammarRules, nodesById: NodesById) {
    super(rules, nodesById, true) // Vieraile kaikissa solmuissa
  }

  public validate(rootNodeId: string): NodeError[] {
    this.errors = []
    this.visit(rootNodeId)
    return this.errors
  }

  private validateFunction(
    node: NormalizedBuilderNode,
    context: VisitorContext,
    functionType: FunctionCategoryValue
  ): void {
    const functionDef = this.rules.functions[functionType]
    if (functionDef) {
      const childCount = node.childIds ? node.childIds.length : 0

      if (childCount < functionDef.min) {
        this.errors.push({
          nodeId: node.id,
          message: 'error:categoryBuilder:function:tooFewParameters',
          messageParams: { min: functionDef.min, current: childCount }
        })
      }

      if (functionDef.max !== null && childCount > functionDef.max) {
        this.errors.push({
          nodeId: node.id,
          message: 'error:categoryBuilder:function:tooManyParameters',
          messageParams: { max: functionDef.max, current: childCount }
        })
      }
    }

    if (!node.value) {
      this.errors.push({
        nodeId: node.id,
        message: 'error:categoryBuilder:node:missingValue',
        messageParams: { type: node.type }
      })
    }
  }

  private validateNodeValue(node: NormalizedBuilderNode): void {
    if (!node.value && !node.argumentId) {
      this.errors.push({
        nodeId: node.id,
        message: 'error:categoryBuilder:node:missingValue',
        messageParams: { type: node.type }
      })
    }
  }

  private validateNodeTermination(node: NormalizedBuilderNode): void {
    if (node.childIds.length === 0) {
      // If it's a leaf node, it should be a terminal type
      if (!this.rules.terminals.includes(node.type)) {
        this.errors.push({
          nodeId: node.id,
          message: 'error:categoryBuilder:node:cantBeTerminal',
          messageParams: { type: node.type }
        })
      }
    }
  }

  private validateReference(node: NormalizedBuilderNode): void {
    if (!this.nodesById[node.value as string]) {
      this.errors.push({
        nodeId: node.id,
        message: 'error:categoryBuilder:node:referenceNotFound',
        messageParams: { type: node.type }
      })
    }
  }

  visitRootNode(node: NormalizedBuilderNode): NodeError[] {
    // Root node is special, it must have children
    if (node.childIds.length === 0) {
      this.errors.push({
        nodeId: node.id,
        message: 'error:categoryBuilder:root:mustHaveChildren'
      })
    }
    return this.errors
  }

  visitCompanyNode(node: NormalizedBuilderNode): NodeError[] {
    this.validateNodeValue(node)
    this.validateNodeTermination(node)
    return this.errors
  }

  // Update all other visit methods similarly
  visitDimensionNode(node: NormalizedBuilderNode): NodeError[] {
    this.validateNodeValue(node)
    this.validateNodeTermination(node)
    return this.errors
  }

  visitPeriodGroupNode(node: NormalizedBuilderNode): NodeError[] {
    this.validateNodeValue(node)
    this.validateNodeTermination(node)
    return this.errors
  }

  visitFunctionNode(node: NormalizedBuilderNode, context: VisitorContext): NodeError[] {
    const functionType = node.value as FunctionCategoryValue
    this.validateFunction(node, context, functionType)
    this.validateNodeTermination(node)
    return this.errors
  }

  visitReferenceNode(node: NormalizedBuilderNode): NodeError[] {
    this.validateNodeValue(node)
    this.validateNodeTermination(node)
    this.validateReference(node)
    return this.errors
  }

  visitKeyFigureNode(node: NormalizedBuilderNode): NodeError[] {
    this.validateNodeValue(node)
    this.validateNodeTermination(node)
    return this.errors
  }

  visitFormulaNode(node: NormalizedBuilderNode): NodeError[] {
    console.log('node', node)
    this.validateNodeValue(node)
    this.validateNodeTermination(node)
    return this.errors
  }
}
